import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getCatalogoCondicao } from '../../../formularios/core/condicao/catalogo'
import { obterProtocolo } from '../../core/_requests'

/**
 * Versão do protocolo da empresa do `:id` da rota e o catálogo de condições, que traduz as regras
 * e condições de exibição para pt-BR.
 */
export const useProtocoloDetalhe = () => {
  const { id } = useParams()
  const idProtocolo = Number(id)

  const protocolo = useQuery(
    ['protocolos-triagem', 'detalhe', idProtocolo],
    () => obterProtocolo(idProtocolo),
    { enabled: !!idProtocolo, retry: false }
  )
  const { data: catalogo } = useQuery(['condicao', 'catalogo'], () => getCatalogoCondicao(), {
    retry: false,
    staleTime: 60 * 60 * 1000,
  })

  return { ...protocolo, catalogo }
}
